import { Skeleton } from "@devhop/ui";

const PLACEHOLDER_KEYS = ["s1", "s2", "s3", "s4", "s5", "s6"] as const;

export function TrainingResourceCardGridSkeleton() {
  return (
    <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3">
      {PLACEHOLDER_KEYS.map((k) => (
        <Skeleton key={k} className="h-40 rounded-xl" />
      ))}
    </div>
  );
}
